const rulesMain = {
  type: '{{value}}',
  brand: '{{value}}',
  period: '{{value}}',
  'radius-krivizny': 'радиуса кривизны {{value}}',
  cvet: 'цвета {{value}}',
  manufacturer: 'производитель {{value}}',
};
const _getWorkValue = (value, filters) => {
  const variants = filters?.variants || [];

  const words = [];
  Object.keys(value).forEach((key) => {
    let label = variants.find((t) => t.slug === key)?.label;
    if (filters?.slug !== 'manufacturer' && filters?.slug !== 'brand') {
      label = (label || '').toLowerCase();
    }

    words.push(label);
  });

  return words.join(', ');
};
const formatFilterMeta = (selectedFilter, slug, appCfg, filters) => {
  const filter = { ...selectedFilter };
  const rules = rulesMain;

  let messages = [];
  Object.keys(rules).forEach((key, index) => {
    if (filter?.[key] && Object.keys(filter?.[key]).length === 1) {
      const value = _getWorkValue(filter?.[key], (filters || []).find((t) => t.slug === key));
      const str = rules[key].replace('{{value}}', value);

      messages.push(str);

      delete filter[key];
    }
  });
  Object.keys(filter).forEach((key) => {
    const filterItem = (filters || []).find((t) => t.slug === key);
    const value = _getWorkValue(filter?.[key], filterItem);
    messages.push(`${filterItem?.name} ${value}`);
  });
  messages = messages.length > 0 ? [messages.join(', ')] : [];

  const city = appCfg?.city?.data?.prepositional || appCfg?.city?.model?.name || '';
  if (!!city && messages.length > 0) {
    messages.push(`в ${city}`);
  }

  if (messages.length <= 0) {
    return '';
  }

  return messages.join(' ');
};

export {
  formatFilterMeta,
};
